<template>
<div class="header">
  <div class="center">
    <img class="logo" src="/static/accountadmin/img_logo_white.png"/>
    <p class="title">Accounts Management</p>

    <img class="logout" src="/static/accountadmin/icon_out.png" @click="logout"/>
    <p class="username">Hello &nbsp;{{username}}</p>
  </div>
</div><!--header 结束-->
</template>

<script>
  import auth from '../../auth/auth'
  export default{
      data(){
        return{
          'username':''
        }
      },
      computed:{

      },
      watch:{

      },
      methods:{
        logout () {
          this.$http.post('/api/v2.1/logout').then(function (res) {
            let error=res.body.error;
            if (0==error) {
              this.$router.push('/managementtools')
            }
          })
        }
      },

    created(){

    },
     mounted(){
      this.username = sessionStorage.getItem('account_admin_username')
     },
  }
</script>

<style scoped>

  .header {
    height:50px;
    background-color:#0c544f;
  }

  .header .center {
    width:80%;
    margin: 0 auto;
  }

  .header .center .logo {
    float:left;
    margin-top:7px;
  }

  .header .center .title {
    float: left;
    color: #fff;
    font-size:16px;
    line-height: 50px;
    margin-left:40px;
  }

  .header .center .logout {
    float:right;
    margin-top:12px;
  }

  .header .center .username {
    color:#fff;
    float:right;
    line-height: 48px;
    margin-right:15px;
  }


</style>



// WEBPACK FOOTER //
// AccountAdminMainHeader.vue?5e02da60